module.exports = __webpack_public_path__ + "static/img/project05.3431773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project05.jpg
// module id = OyTx
// module chunks = 1